<template>
  <div class="container-fluid footer-wrapper">
    <b-row>
		<b-col cols="12" class="p-0">
			<div class="container">
				<b-row class="pt-4">
					<b-col md="3" class="align-middle text-md-left text-center mt-md-2 mb-3 mb-md-0">
						<img src="../assets/images/Logo_SonagiWhite-01.svg">
					</b-col>
					<b-col md="9" class="align-middle text-md-right text-center footer-nav pt-2">
						<p class="d-block d-md-inline-block mb-md-0"><router-link class="menu-link text-white d-inline-block mr-lg-3 mr-md-2" :to="'/' +$route.params.lang+ '/'" :class="($route.name) == 'home' ? 'line-up-white' : 'border-ani-center-white'">{{configs['menu_home']}}</router-link></p>
						<p class="d-block d-md-inline-block mb-md-0"><router-link class="menu-link text-white d-inline-block mr-lg-3 ml-lg-3 mr-md-2 ml-md-2" :to="'/' +$route.params.lang+ '/about'" :class="($route.name) == 'about' ? 'line-up-white' : 'border-ani-center-white'">{{configs['menu_about_us']}}</router-link></p>
						<p class="d-block d-md-inline-block mb-md-0"><router-link class="menu-link text-white d-inline-block mr-lg-3 ml-lg-3 mr-md-2 ml-md-2" :to="'/' +$route.params.lang+ '/portfolio/real-estate-investement'" :class="($route.name) == 'portfolio' ? 'line-up-white' : 'border-ani-center-white'">{{configs['menu_portfolio']}}</router-link></p>
						<p class="d-block d-md-inline-block mb-md-0"><router-link class="menu-link text-white d-inline-block mr-lg-3 ml-lg-3 mr-md-2 ml-md-2" :to="'/' +$route.params.lang+ '/investors'" :class="($route.name) == 'investors' ? 'line-up-white' : 'border-ani-center-white'">{{configs['menu_investors']}}</router-link></p>
						<p class="d-block d-md-inline-block mb-md-0"><router-link class="menu-link text-white d-inline-block ml-lg-3 ml-md-2" :to="'/' +$route.params.lang+ '/contacts'" :class="($route.name) == 'contacts' ? 'line-up-white' : 'border-ani-center-white'">{{configs['menu_contacts']}}</router-link></p>
					</b-col>
				</b-row>
				<b-row class="pb-4">
					<b-col cols="12" class="pt-4 text-md-left text-center">
						<p class="text-white">
							Av. Fontes Pereira de Melo, 14 - 7º,
							<br>
							1050-121 Lisboa - Portugal
						</p>
						<p class="text-white mb-0">
							<a href="callto:+351213184800">
                            	+351 21 318 48 00
                            </a>
							<br>
							+351 21 357 22 60
							<br>
							<a href="mailto:sonagi@sonagi.pt">sonagi@sonagi.pt</a>
						</p>
					</b-col>
					<b-col lg="6" offset-md="6" class="mt-3 mt-md-0 position-relative copy">
						<div>
							<p class="text-white text-md-right text-center section-title m-0">ALL RIGHTS RESERVED TO SONAGI</p></div>
					</b-col>
				</b-row>
			</div>
		</b-col>
	</b-row>
  </div>
</template>
<script>
export default {
  name: 'Footer',
}
</script>
<style>
.footer-wrapper {
	background-color: #00263d;
	position: relative;
	z-index: 1; /* so the animation doesn't be up - ex: contacts page */
}
.footer-wrapper a.menu-link {
	text-decoration: none;
}
.footer-wrapper a:not(.menu-link) {
  text-decoration: none;
  color: inherit;
}
.footer-wrapper a:hover {
  text-decoration: underline;
}
.footer-wrapper a.menu-link:hover {
  text-decoration: none;
}
.footer-wrapper p {
	font-size: 0.9rem;
}
.footer-wrapper .copy p {
	bottom: 0;
	right: 15px;
	position: absolute;
	font-size: 10px;
}
@media screen and (max-width:991.98px) {
	.footer-wrapper .copy p {
		bottom: 0;
		position: static;
	}
}
</style>